
import { LedgerAccount } from "@/models/ledger-account";
import { LedgerAccountService } from "@/services/ledger-account-service";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";
import { TranslateResult } from "vue-i18n";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { DiverseLedger } from "@/models/base/diverse-ledger";
import { BankType } from "@/models/base";
import { BankService } from "@/services";

export default FormLike.extend({
	data(){
		return {
			accounts: [] as LedgerAccount[],
			inputs: {
				code: "",
				debet: 0,
				credit: 0,
				comment: ""
			},
			banks: [] as BankType[]
		};
	},
	props: {
		value: {
			type: Object as ()=>DiverseLedger,
			required: true
		}
		,ledgers: {
			type: Array as ()=>DiverseLedger[]
		}
	},
	computed: {
		selectedAccount():LedgerAccount {
			let account = this.accounts.find(c=>c.Code == this.inputs.code);
			if (!account) {
				account = this.accounts[0];
				if (!account) {
					account = new LedgerAccount();
				}
			}
			return account;
		},
		vatField():string | TranslateResult{
			if (this.selectedAccount.VatField == 0){
				return this.$ct("common.none");
			}
			return `${this.selectedAccount.VatField}`;
		},
		showRemoveButton(): boolean {
			return this.ledgers.indexOf(this.value) != -1;
		},
		ledgerAccountValid():boolean {
			if (!this.inputs.code) return true;
			for (let b of this.banks) {
				if (b.LedgerNumber == this.inputs.code) {
					return false;
				}
			}
			return true;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.inputs.code = this.value.LedgerCode;
				this.inputs.debet = this.value.Debet;
				this.inputs.credit = this.value.Credit;
				this.inputs.comment = this.value.Comment;
			}
		},
		inputs: {
			deep: true,
			handler(){
				this.validate();
			}
		}
	},
	methods: {
		validate(){
			this.isValid = true;
			if (this.inputs.code == "") {
				this.isValid = false;
			}
			if (this.inputs.code.indexOf(".") != -1) {
				this.isValid = false;
			}
			if (!this.ledgerAccountValid) {
				this.isValid = false;
			}
		},
		add(){
			this.validate();
			if (!this.isValid) return;
			let ledger = new DiverseLedger(this.value);
			ledger.LedgerCode = this.inputs.code;
			ledger.Debet = this.inputs.debet;
			ledger.Credit = this.inputs.credit;
			ledger.Comment = this.inputs.comment;
			ledger.LedgerAccount = this.accounts.find(l=>l.Code == ledger.LedgerCode) || null;
			this.$emit("input", ledger);
		},
		remove(){
			this.$emit("remove");
		},
		focus(key:string){
			let el = this.$refs[key] as HTMLElement | undefined;
			if (!el) return;
			if (!el.focus) return;
			el.focus();
		},
		isCodeValid(code:string):boolean{
			for (let b of this.banks) {
				if (b.LedgerNumber == code) {
					return false;
				}
			}
			return true;
		},
		onCode(code:string){
			for (let b of this.banks) {
				if (b.LedgerNumber == code) {
					// Run in next frame to prevent enters from immediatly closing the modal
					requestAnimationFrame(()=>{
						let message = this.$ct("ledger-account-code-is-not-allowed-cause-used-in-bank", {code, bankNr: b.ID, bankName: b.getName()});
						this.$wf.dialog(message, this.$ct("common.Ok"), this.$ct("common.error"), "warning");
					});
					return;
				}
			}
			this.inputs.code = code;
			this.focus("debet");
		}
	},
	async created(){
		this.accounts = (await LedgerAccountService.fetchLedgerAccounts()).filter(a=>!a.isGroup());
		this.banks = BankService.getTypes();
		//this.inputs.code = this.accounts[0].Code;
	},
	components: {
		AppLedgerAccountAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.bookkeeping"
	}
});
